import * as ts from 'type-schema';

const _schema = ts.object({
    email: ts.string(),
    name: ts.string().nullable(),
    picture: ts.string().nullable(),
    exp: ts.number().transformer(n => new Date(n * 1000)),
});

export type user = ts.buildType<typeof _schema>;

export namespace user {
    export const schema = _schema;
}
